import { gql } from '@apollo/client';

export const insertEraCareEventMutation = gql`
  mutation ($object: era_care_events_insert_input!) {
    insert_era_care_events_one(object: $object) {
      id
    }
  }
`;
